import { Chip, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    chip: {
        borderRadius: "6.25rem",
        height: "2.25rem",
        padding: "0 .25rem",
        background: theme.palette.tailwind.blue[50],
        color: theme.palette.primary.main,
        "&:hover": {
            background: theme.palette.tailwind.blue[100],
        },
        "& .MuiChip-label": {
            padding: "0 .5rem 0 .75rem",
        },
        "& .MuiChip-icon": {
            margin: "0 0 0 .625rem",
            fontSize: ".875rem",
            color: theme.palette.primary.main,
        },
        "& .MuiChip-deleteIcon": {
            fontSize: "1.125rem",
            margin: "0 .375rem 0 0",
            transition: "all ease-out 0.3s",
            color: theme.palette.primary.main,
            opacity: 0.6,
            "&:hover": {
                color: theme.palette.primary.main,
                opacity: 1,
            },
        },
    },
    label: {
        fontWeight: 600,
    },
}))

type Props = Readonly<{
    label: string
    icon?: IconDefinition
    /** Set when the chip opens its own value picker. */
    onClick?: () => void
    onRemove: () => void
    className?: string
}>

export function StandardFilterChip({ label, icon, onClick, onRemove, className }: Props) {
    const { classes, cx } = useStyles()

    return (
        <Chip
            label={
                <Typography variant="body2" component="span" className={classes.label}>
                    {label}
                </Typography>
            }
            icon={icon ? <FontAwesomeIcon icon={icon} /> : undefined}
            onClick={onClick}
            onDelete={onRemove}
            className={cx(classes.chip, className)}
        />
    )
}
